import React, { useState } from "react";
import { Container } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

const ContactUs = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted!", { name, email, phoneNumber, message });
    setName("");
    setEmail("");
    setPhoneNumber("");
    setMessage("");
  };

  return (
    <Container fluid className="about-section" id="contactus">
      <div className="contact-panel glass-card">
        <h1 className="contactus-head" style={{ textAlign: "center" }}>
          Get in Touch
        </h1>
        <p
          className="contactus-subhead"
          style={{ textAlign: "center", marginBottom: 24 }}
        >
          Please fill out the form below to get in touch with me.
        </p>
        <p
          className="contactus-subhead"
          style={{ textAlign: "center", marginBottom: 24 }}
        >
          Currently available for freelance projects and collaborations.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            placeholder="Enter your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="email"
            placeholder="Enter your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            placeholder="Enter your Phone Number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
          <textarea
            placeholder="What's on your mind?"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
          <button type="submit" className="btn btn-primary" style={{ width: "100%" }}>
            Submit
          </button>
        </form>

        <div style={{ textAlign: "center", marginTop: 28 }}>
          <div
            className="social-media-links"
            style={{ justifyContent: "center" }}
          >
            <a
              href="https://twitter.com/16Soheel"
              target="_blank"
              rel="noreferrer"
              aria-label="Twitter"
            >
              <AiOutlineTwitter />
            </a>
            <a
              href="https://github.com/SoheelGadad"
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub"
            >
              <AiFillGithub />
            </a>
            <a
              href="https://www.linkedin.com/in/soheel-gadad"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://www.instagram.com/c_o_d_e_cracker/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <AiFillInstagram />
            </a>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ContactUs;